import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { LifeBuoy } from "lucide-react";
import { SearchSelect } from "@/components/filters/FilterMultiSelect";

export const SUPPORT_SERVICES = ["RH", "Achat", "Maintenance", "Qualité", "Marketing", "Autre"];
export const emptyEscalation = () => ({ enabled: false, support_service: "", support_person_id: "", description: "" });

/* Crée le SupportTicket lié à la source une fois celle-ci enregistrée. Ne lève pas : renvoie null en cas d'échec. */
export async function createEscalationTicket(esc, { source_type, source_id, titre, corner_key, store_id }) {
  if (!esc?.enabled || !esc.support_service) return null;
  try {
    const r = await api.post("/support-tickets", {
      source_type, source_id, support_service: esc.support_service,
      support_person_id: esc.support_person_id || null,
      titre: titre || `Escalade ${esc.support_service}`,
      description: esc.description || null, priorite: "Normal",
      corner_key: corner_key || null, store_id: store_id || null,
    });
    return r.data;
  } catch { return null; }
}

export default function SupportEscalationSection({ value, onChange, testid = "esc" }) {
  const esc = value || emptyEscalation();
  const set = (k, v) => onChange({ ...esc, [k]: v });
  const [users, setUsers] = useState([]);
  useEffect(() => {
    if (!esc.enabled || users.length) return;
    api.get("/support-tickets/meta").then(r => setUsers(r.data?.support_users || [])).catch(() => {});
  }, [esc.enabled, users.length]);
  const people = users.filter(u => !esc.support_service || !u.support_service || u.support_service === esc.support_service)
                      .sort((a, b) => (a.support_service === esc.support_service ? -1 : 1) - (b.support_service === esc.support_service ? -1 : 1) || (a.name || "").localeCompare(b.name || ""));
  return (
    <div className={`rounded-xl border p-4 space-y-3 ${esc.enabled ? "border-indigo-200 bg-indigo-50/40" : "border-slate-200 bg-slate-50/50"}`} data-testid={`${testid}-section`}>
      <label className="flex items-center gap-3 cursor-pointer select-none">
        <button type="button" role="switch" aria-checked={esc.enabled} onClick={() => set("enabled", !esc.enabled)} data-testid={`${testid}-toggle`}
                className={`relative w-10 h-5 rounded-full transition-colors ${esc.enabled ? "bg-indigo-600" : "bg-slate-300"}`}>
          <span className={`absolute top-0.5 left-0.5 w-4 h-4 rounded-full bg-white shadow transition-transform ${esc.enabled ? "translate-x-5" : ""}`}/>
        </button>
        <span className="flex items-center gap-2 text-sm font-semibold text-slate-800"><LifeBuoy className="w-4 h-4 text-indigo-600"/> Envoyer vers un service support</span>
      </label>
      {esc.enabled && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div>
            <label className="text-[11px] font-bold uppercase text-slate-500 block mb-1">Service support *</label>
            <SearchSelect value={esc.support_service} onChange={v => onChange({ ...esc, support_service: v, support_person_id: "" })} options={SUPPORT_SERVICES.map(s => ({ value: s, label: s }))} placeholder="— Choisir un service —" data-testid={`${testid}-service`} size="lg" menuWidth={220}/>
          </div>
          <div>
            <label className="text-[11px] font-bold uppercase text-slate-500 block mb-1">Personne destinataire</label>
            <SearchSelect value={esc.support_person_id} onChange={v => set("support_person_id", v)} options={people.map(u => ({ value: u.id, label: `${u.name}${u.support_service ? ` · ${u.support_service}` : ""}` }))} placeholder="— Optionnel —" data-testid={`${testid}-person`} size="lg" menuWidth={260}/>
          </div>
          <div className="col-span-full">
            <label className="text-[11px] font-bold uppercase text-slate-500 block mb-1">Description du problème</label>
            <textarea rows={2} value={esc.description} onChange={e => set("description", e.target.value)} data-testid={`${testid}-description`} placeholder="Ce que le service support doit traiter…"
                      className="w-full text-sm px-3 py-2 rounded-lg border border-slate-200 outline-none focus:border-indigo-400 bg-white"/>
          </div>
          <p className="col-span-full text-[11px] text-slate-500">Un ticket support « Nouveau » (priorité Normal) sera créé automatiquement à l'enregistrement et lié à cette fiche.</p>
        </div>
      )}
    </div>
  );
}
